<template>
  <mailbox-verification-layout :name="mailboxName" show-cancel-option>
    <el-card>
      <template #header>
        <h3>Auto-forward emails into this mailbox</h3>
      </template>
      <entity-settings-loading v-if="isLoading" />
      <div v-else class="mailbox-verification-intro">
        <p>
          Set up an auto-forwarding rule from 
          an <strong>existing email account</strong> (e.g. your customer support or feedback address) 
          so you can manage all future email conversations inside this mailbox.
        </p>
        <p><br></p>
        <h5>
          The email address you'll be forwarding from
        </h5>
        <standard-email-input 
          v-model="forwardingAddress" 
          placeholder="e.g. support@mycompany.com" 
          @valid="emailValidated=true" 
          @invalid="emailValidated=false"
        />
        <p><br></p>
        <p class="small">
          <strong>Note:</strong> You need administrative access to this 
          email account to complete the auto-forwarding setup.
        </p>
        <p><br></p>
        <dd-button
          :is-loading="isSubmitting"
          :is-disabled="disableSubmit"
          :color="ColorAssistant.MailboxColor"
          full-width
          size="large"
          @click="addAutoForwardingAddress"
        >Walk me through auto-forwarding into this mailbox</dd-button>
      </div>
    </el-card>
  </mailbox-verification-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MailboxVerificationLayout from '@/layouts/mailbox-verification-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'
import LocalStore from '@/helpers/localstore'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default defineComponent({

  components: {
    MailboxVerificationLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
      LocalStore,
      mailboxName: '',
      isLoading: true,
      isSubmitting: false,
      emailValidated: false,
      forwardingAddress: '',
    }
  },
  head: {
    title: 'Set up Auto-Forwarding',
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    disableSubmit(): boolean {
      return !this.emailValidated
    },
  },

  async created() {
    this.isLoading = true
    await this.getMailboxName()
    this.isLoading = false
  },

  methods: {
    async getMailboxName() {
      try {
        const response = await MailboxesAPI.get_Title(this.mailboxID)
        this.mailboxName = response.name
      } catch (err) {
        this.$error.emit(err)
      }
    },
    async addAutoForwardingAddress() {
      LocalStore.mailboxForwardingAddressCandidate = this.forwardingAddress
      RouteAssistant.goToMailboxVerificationAutoForwardingRoute(
        this.$router,
        this.$route.params.accountId,
        this.mailboxID,
      )
    },
  },
})
</script>
